import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import isSearchOpenAtom from './isSearchOpenAtom';
const useCloseSearch = () => {
  const $ = _c(2);
  const setIsSearchOpen = useSetAtom(isSearchOpenAtom);
  let t0;
  if ($[0] !== setIsSearchOpen) {
    t0 = () => {
      setIsSearchOpen(false);
    };
    $[0] = setIsSearchOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const closeSearch = t0;
  return closeSearch;
};
export default useCloseSearch;